import React from "react";
import { Input, AutoComplete, Icon, Select } from "antd";
import {searchOriginatorNameForSelector} from "api/api";
import { displayGenericError } from "common/notifications";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";

class OriginatorSelectionComponent extends React.Component {
    state = {
        dataSource: [],
        searchResults: [],
        selection: null
    };

    searchTimerID = null;
    onChange = value =>{
        if (value === '') {
            this.props.onClear();
        } else {
            this.props.onChange(value);
        }
    }
    onSelect = value => {
        let selectedOriginator = null;
        for (let i = 0; i < this.state.searchResults.length; i++) {
            if (this.state.searchResults[i].id == value) {
                selectedOriginator = this.state.searchResults[i];
                break;
            }
        }
        this.props.onSelected(selectedOriginator);
    };

    handleSearch = value => {
        clearTimeout(this.searchTimerID);
        this.searchTimerID = setTimeout(() => {
            searchOriginatorNameForSelector(value)
                .then(response => {
                    this.setState({
                        searchResults: response,
                        dataSource: response
                    });
                })
                .catch(error => {
                    displayGenericError(error);
                });
        }, 250);
    };

    renderOption = item => {
        return (
            <Select.Option key={item.id} text={item.displayName}>
                <span className="searchResult">{item.displayName}</span>
            </Select.Option>
        );
    };

    render() {
        const intl = this.props.useIntl;
        return (
            <div style={this.props.style}>
                <AutoComplete
                    className="global-search"
                    size="large"
                    style={{width: '100%'}}
                    dataSource={this.state.dataSource.map(this.renderOption)}
                    onChange={this.onChange}
                    onSelect={this.onSelect}
                    onSearch={this.handleSearch}
                    optionLabelProp="text"
                >
                    <Input
                        style={{...this.props.style}}
                        placeholder={intl.formatMessage({id: "app.component.originatorselectioncomponent.sendername"})}
                        prefix={<Icon type="search" />}
                    />
                </AutoComplete>
            </div>
        );
    }
}

export default withUseIntl(OriginatorSelectionComponent);